export default function formatTime (timestamp) {
    return new Date(parseInt(timestamp)).toLocaleTimeString('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
    });
  };
